/* One global delivery window, counted in calendar weeks using the studio's date. */
(() => {
  if (customElements.get('vensoul-delivery-estimate')) return;
  const studioDate = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Lisbon', year: 'numeric', month: '2-digit', day: '2-digit'
  });
  const shortDate = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', day: 'numeric', month: 'short' });
  const fullDate = new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', day: 'numeric', month: 'short', year: 'numeric' });
  const instances = new Set();
  let timer;

  function refresh() {
    if (!document.hidden) instances.forEach(element => element.update());
  }

  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      instances.add(this);
      this.update();
      // A cached page, section replacement or tab left open must not keep yesterday's dates.
      if (!timer) timer = window.setInterval(refresh, 60000);
    }

    disconnectedCallback() {
      instances.delete(this);
      if (!instances.size) { window.clearInterval(timer); timer = undefined; }
    }

    static get observedAttributes() { return ['data-min-weeks', 'data-max-weeks']; }
    attributeChangedCallback() { if (this.isConnected) this.update(); }

    update() {
      const parts = Object.fromEntries(studioDate.formatToParts(new Date()).map(part => [part.type, part.value]));
      const today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
      const min = Math.max(1, Math.min(52, Math.trunc(Number(this.dataset.minWeeks)) || 3));
      const max = Math.max(min, Math.min(52, Math.trunc(Number(this.dataset.maxWeeks)) || 5));
      const key = `${today.toISOString()}/${min}/${max}`;
      if (this.dateKey === key) return;
      const start = new Date(today);
      const end = new Date(today);
      // Calendar arithmetic in UTC avoids losing a day at daylight-saving transitions.
      start.setUTCDate(start.getUTCDate() + min * 7);
      end.setUTCDate(end.getUTCDate() + max * 7);
      const long = min === max ? fullDate.format(start) : `${fullDate.format(start)} – ${fullDate.format(end)}`;
      const formatter = start.getUTCFullYear() === end.getUTCFullYear() ? shortDate : fullDate;
      const short = min === max ? formatter.format(start) : `${formatter.format(start)} – ${formatter.format(end)}`;
      const range = this.querySelector('[data-delivery-range]');
      if (!range) return; // Wait for markup when a section is inserted dynamically.
      range.textContent = long;
      this.querySelector('[data-delivery-today]').textContent = shortDate.format(today);
      this.querySelector('[data-delivery-short]').textContent = short;
      this.dateKey = key;
    }
  }
  customElements.define('vensoul-delivery-estimate', DeliveryEstimate);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
})();
